import { render, staticRenderFns } from "./NodeAuthorization.vue?vue&type=template&id=edd696ea&scoped=true&"
import script from "./NodeAuthorization.vue?vue&type=script&lang=js&"
export * from "./NodeAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./NodeAuthorization.vue?vue&type=style&index=0&id=edd696ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd696ea",
  null
  
)

export default component.exports